import { IIntegratedCareReturnDelivery } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { IntegratedCareReturnDeliveryWorkItem } from 'src/app/business/integrated-care-return-delivery/integrated-care-return-delivery-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class IntegratedCareReturnDeliveryCommandHandler extends EntityCommandHandler<IIntegratedCareReturnDelivery> {
  protected workItem: IWorkItem<IIntegratedCareReturnDelivery>;

  constructor(integratedCareReturnDeliveryWorkItem: IntegratedCareReturnDeliveryWorkItem) {
    super();
    this.workItem = integratedCareReturnDeliveryWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'IntegratedCareReturnDeliveryDto';
  }
}
